/* Frontend Masonry grid for Judge.me reviews */
(function(){
  function normalizeApiBase(v){
    if(!v) return '';
    const u = String(v).trim().replace(/\/+$/,'');
    return /\/api$/.test(u) ? u : `${u}/api`;
  }
  function getUrlParam(name){
    try { const sp = new URLSearchParams(location.search); return sp.get(name) || ''; } catch(_) { return ''; }
  }
  let API_BASE = (() => {
    const override = getUrlParam('jdgm_api_base') || getUrlParam('api') || (window.JDGM_GRID_API_BASE || '');
    const norm = normalizeApiBase(override);
    return norm || '/api';
  })();
  const DEBUG = (() => {
    try {
      const sp = new URLSearchParams(location.search);
      const v = (sp.get('jdgm_debug') || sp.get('debug') || '').toLowerCase();
      return ['1','true','yes','on'].includes(v);
    } catch(_) { return false; }
  })();

  function boolAttr(v, def){
    if (v === undefined) return !!def;
    const s = String(v).toLowerCase().trim();
    if (s === '1' || s === 'true' || s === 'yes' || s === 'on') return true;
    if (s === '0' || s === 'false' || s === 'no' || s === 'off') return false;
    // Empty string from present-but-empty attribute should NOT auto-true; fall back to default
    if (s === '') return !!def;
    return false;
  }

  function filledStar(){
    return `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>`;
  }
  function emptyStar(){
    return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>`;
  }

  function stars(rating){
    const val = Math.max(0, Math.min(5, parseFloat(rating) || 0));
    let html = '';
    for(let i=1;i<=5;i++){
      const fill = Math.max(0, Math.min(1, val - (i-1))); // 0..1
      const pct = Math.round(fill * 100);
      html += `<span class="jdgm-star" aria-hidden="true"><span class="jdgm-star-empty">${emptyStar()}</span><span class="jdgm-star-fill" style="width:${pct}%">${filledStar()}</span></span>`;
    }
    return `<div class="jdgm-stars" aria-label="${val.toFixed(1)} out of 5 stars">${html}</div>`;
  }

  function mediaHtml(m){
    if(!m) return '';
    if(m.type === 'video'){
      const poster = m.thumbnail || '';
      return `<div class="jdgm-media"><video controls preload="metadata" ${poster?`poster='${escapeHtml(poster)}'`:''} src="${escapeHtml(m.url)}"></video><span class="jdgm-video-badge">Video</span></div>`;
    }
    return `<div class="jdgm-media"><img loading="lazy" src="${escapeHtml(m.url)}" alt="Customer media"/></div>`;
  }

  function cardHtml(r, opts){
    // Gate media usage strictly by upstream has_published_* when available
    const media0 = (Array.isArray(r.media) && r.media.length) ? r.media[0] : null;
    const flagsKnown = (r.has_published_pictures !== undefined) || (r.has_published_videos !== undefined);
    const flagsAllowMedia = (r.has_published_pictures === true) || (r.has_published_videos === true);
    const m = flagsKnown ? (flagsAllowMedia ? media0 : null) : media0;

    // Resolve product context for title/link (no fallback image rendering)
    const fp = opts.fallbackProduct || {};
    let pTitle = '', pVariant = '', pUrl = '';
    if (opts.all && r.product){
      pTitle = r.product.title || '';
      pVariant = r.product.variant_title || r.variant_title || '';
      if (r.product.url) pUrl = r.product.url;
      else if (r.product.handle && opts.shopDomain){ pUrl = `https://${opts.shopDomain}/products/${r.product.handle}`; }
    } else {
      pTitle = fp.title || '';
      pVariant = fp.variant || '';
      pUrl = fp.url || '';
    }
    const prodLine = pTitle ? `<div class='jdgm-prodline'><a href='${escapeHtml(pUrl || '#')}' target='_top' rel='noopener'>${escapeHtml(pTitle)}${pVariant?` — ${escapeHtml(pVariant)}`:''}</a></div>` : '';

    const title = (opts.showTitle && r.title) ? `<div class='jdgm-title'>${escapeHtml(r.title)}</div>` : '';
    const body = r.body ? `<div class='jdgm-text'>${escapeHtml(truncate(r.body, 220))}</div>` : '';
    const rating = opts.showStars ? stars(r.rating) : '';
    const author = (opts.showAuthor && r.author) ? `<div class='jdgm-author'>${escapeHtml(r.author)}</div>` : '';
    let media = '';
    if (m) {
      media = mediaHtml(m);
    }
    return `<article class="jdgm-card">${media}<div class="jdgm-body">${rating}${prodLine}${title}${body}${author}</div></article>`;
  }

  function escapeHtml(s){
    return (s || '').replace(/[&<>"']/g, (m) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[m]);
  }
  function truncate(s, n){ if(!s) return s; return s.length>n ? s.slice(0,n-1)+'…' : s; }

  function ctaHtml(href){
    const target = href || '#judgeme_product_reviews';
    return `<div class="jdgm-cta-wrap"><a class="jdgm-cta" href="${escapeHtml(target)}">Review this product</a></div>`;
  }

  async function fetchPage({ apiBase, productId, shopDomain, page, perPage, all, filterMode, forceKey }){
    const base = all ? `${apiBase}/reviews/all` : `${apiBase}/reviews`;
    let query = all
      ? `page=${page}&per_page=${perPage}${shopDomain?`&shop_domain=${encodeURIComponent(shopDomain)}`:''}`
      : `product_id=${encodeURIComponent(productId)}&page=${page}&per_page=${perPage}${shopDomain?`&shop_domain=${encodeURIComponent(shopDomain)}`:''}`;
    if (forceKey) query += `&force_key=${encodeURIComponent(forceKey)}`;
    if (DEBUG) query += `&debug=1`;
    const url = `${base}?${query}`;
    try { console.info('[JDGM] GET', url); } catch(_){ }
    const res = await fetch(url);
    let json = null;
    try { json = await res.json(); } catch(_){ /* non-JSON error */ }
    if(!res.ok){
      const msg = (json && (json.error || json.detail)) || res.statusText || 'Failed to fetch reviews';
      const err = new Error(msg);
      try { err.status = res.status; err.payload = json; } catch(_){ }
      throw err;
    }
    try {
      const n = (json && json.reviews && json.reviews.length) || 0;
      console.info('[JDGM] Reviews returned:', n);
      if (DEBUG && n === 0) console.warn('[JDGM DEBUG] 0 reviews from server. If product has reviews, ensure section Filter is not set to "Media only" (client now fetches all and filters locally).');
    } catch(_){ }
    return json;
  }

  function init(container){
    const productId = container.dataset.productId;
    const shopDomain = container.dataset.shopDomain || undefined;
    const perPage = parseInt(container.dataset.perPage || '50', 10);
    const allAttr = boolAttr(container.dataset.all, false);
    const initialAll = productId ? false : allAttr; // default to "This product" when a productId is available
    const showStars = boolAttr(container.dataset.showStars, true);
    const showTitle = boolAttr(container.dataset.showTitle, true);
    const showAuthor = boolAttr(container.dataset.showAuthor, false);
    const filterMode = (container.dataset.filter || 'media_or_text').toLowerCase(); // none | media_or_text | media_only | text_only
    const infinite = boolAttr(container.dataset.infinite, true); // when false, disable infinite scroll
    const containerBase = normalizeApiBase(container.dataset.apiBase || '');
    const apiBase = containerBase || API_BASE;
    const forceKey = (container.dataset.forceKey || '').trim();
    if (DEBUG) { try { console.info('[JDGM DEBUG] Using API base:', apiBase); } catch(_){} }

    const wrap = document.createElement('div');
    wrap.className = 'jdgm-grid-wrap';
    if (container.dataset.accent) {
      try { wrap.style.setProperty('--jdgm-accent', container.dataset.accent); } catch(_){}
    }
    if (container.dataset.ctaBg) {
      try { wrap.style.setProperty('--jdgm-cta-bg', container.dataset.ctaBg); } catch(_){}
    }
    if (container.dataset.ctaText) {
      try { wrap.style.setProperty('--jdgm-cta-text', container.dataset.ctaText); } catch(_){}
    }

    // Top-right toolbar: scope (Product/All) and filter (All/Media)
    const toolbar = document.createElement('div');
    toolbar.className = 'jdgm-toolbar';

    const scopeSeg = document.createElement('div');
    scopeSeg.className = 'jdgm-seg';
    const btnProduct = document.createElement('button'); btnProduct.type = 'button'; btnProduct.textContent = 'Product'; btnProduct.title = 'Reviews for this product';
    const btnAllStore = document.createElement('button'); btnAllStore.type = 'button'; btnAllStore.textContent = 'All store'; btnAllStore.title = 'Reviews from the entire store';
    scopeSeg.appendChild(btnProduct); scopeSeg.appendChild(btnAllStore);

    const filterSeg = document.createElement('div');
    filterSeg.className = 'jdgm-seg';
    const btnAll = document.createElement('button'); btnAll.type = 'button'; btnAll.textContent = 'All reviews'; btnAll.title = 'Show reviews with or without media';
    const btnMedia = document.createElement('button'); btnMedia.type = 'button'; btnMedia.textContent = 'Media only'; btnMedia.title = 'Show only reviews with photos or videos';
    filterSeg.appendChild(btnAll); filterSeg.appendChild(btnMedia);

    toolbar.appendChild(scopeSeg);
    toolbar.appendChild(filterSeg);
    wrap.appendChild(toolbar);

    const grid = document.createElement('div');
    grid.className = 'jdgm-masonry';
    wrap.appendChild(grid);

    const controls = document.createElement('div');
    controls.className = 'jdgm-controls';

    const loader = document.createElement('div');
    loader.className = 'jdgm-loader';
    loader.textContent = 'Loading reviews…';
    loader.style.display = 'none';

    const moreBtn = document.createElement('button');
    moreBtn.className = 'jdgm-more-btn';
    moreBtn.type = 'button';
    moreBtn.textContent = 'Load more';
    moreBtn.addEventListener('click', () => load());

    controls.appendChild(loader);
    controls.appendChild(moreBtn);
    let debugPre = null;
    if (DEBUG) {
      const details = document.createElement('details');
      details.className = 'jdgm-debug';
      const summary = document.createElement('summary');
      summary.textContent = 'Debug: Upstream Judge.me payload';
      debugPre = document.createElement('pre');
      debugPre.className = 'jdgm-debug-pre';
      details.appendChild(summary);
      details.appendChild(debugPre);
      try { details.open = true; } catch(_){}
      controls.appendChild(details);
    }
    wrap.appendChild(controls);

    container.appendChild(wrap);

    let page = 1, loading = false, done = false;
    const state = { all: initialAll, filterMode };

    function updateToolbar(){
      // Scope buttons
      btnProduct.disabled = !productId;
      if (state.all) {
        btnAllStore.classList.add('active'); btnAllStore.setAttribute('aria-pressed','true');
        btnProduct.classList.remove('active'); btnProduct.setAttribute('aria-pressed','false');
      } else {
        btnProduct.classList.add('active'); btnProduct.setAttribute('aria-pressed','true');
        btnAllStore.classList.remove('active'); btnAllStore.setAttribute('aria-pressed','false');
      }
      // Filter buttons
      if (state.filterMode === 'media_only') {
        btnMedia.classList.add('active'); btnMedia.setAttribute('aria-pressed','true');
        btnAll.classList.remove('active'); btnAll.setAttribute('aria-pressed','false');
      } else {
        btnAll.classList.add('active'); btnAll.setAttribute('aria-pressed','true');
        btnMedia.classList.remove('active'); btnMedia.setAttribute('aria-pressed','false');
      }
    }

    function resetAndLoad(){
      // Clear grid and reset pagination
      grid.innerHTML = '';
      page = 1; done = false; loading = false;
      loader.textContent = 'Loading reviews…'; loader.style.display = 'none';
      moreBtn.disabled = false; moreBtn.textContent = 'Load more';
      load();
    }

    btnProduct.addEventListener('click', () => { if (!productId) return; state.all = false; updateToolbar(); resetAndLoad(); });
    btnAllStore.addEventListener('click', () => { state.all = true; updateToolbar(); resetAndLoad(); });
    btnAll.addEventListener('click', () => { state.filterMode = 'media_or_text'; updateToolbar(); resetAndLoad(); });
    btnMedia.addEventListener('click', () => { state.filterMode = 'media_only'; updateToolbar(); resetAndLoad(); });

    updateToolbar();

    async function load(){
      if(loading || done) return; loading = true; loader.style.display = 'block';
      try{
        // Guard: if product-specific view is required but productId is missing
        if(!state.all && !productId){
          loader.style.display = 'none';
          grid.insertAdjacentHTML('beforebegin', ctaHtml(container.dataset.reviewUrl));
          moreBtn.disabled = true;
          moreBtn.textContent = 'No reviews yet';
          try { console.warn('[JDGM] Missing productId for product-specific mode. Ensure section is on a product template.'); } catch(_){}
          if (DEBUG && debugPre) {
            try { debugPre.textContent = 'Missing productId for product-specific mode. Ensure this section is used on a product page so {{ product.id }} is available.'; } catch(_){}
          }
          done = true; return;
        }
        const data = await fetchPage({ apiBase, productId, shopDomain, page, perPage, all: state.all, filterMode: state.filterMode, forceKey });
        if (DEBUG && data) {
          if (data.upstream) {
            try { console.log('[JDGM DEBUG] Upstream response:', data.upstream); } catch(_){ }
          }
          if (typeof data.resolutionFailed !== 'undefined' || data.resolution) {
            try { console.log('[JDGM DEBUG] Product resolution:', data.resolution, 'failed:', data.resolutionFailed); } catch(_){}}
          if (data.pathsTried) {
            try { console.log('[JDGM DEBUG] Paths tried:', data.pathsTried); } catch(_){ }
          }
          if (debugPre) {
            try { debugPre.textContent = JSON.stringify({ upstream: data.upstream || null, resolution: data.resolution || null, resolutionFailed: !!data.resolutionFailed, pathsTried: data.pathsTried || null, input: data.input || null }, null, 2); } catch(_){}
          }
        }
        let list = data.reviews || [];
        // Fallback: if product-specific fetch returns empty on first page, try sitewide then filter by current product handle
        if (!state.all && page === 1 && (!list || list.length === 0)) {
          let handle = '';
          try {
            const pu = container.dataset.productUrl || '';
            const m = pu.match(/\/products\/([^\/\?#]+)/);
            handle = m ? m[1] : '';
          } catch(_){ }
          if (handle) {
            try {
              const dataAll = await fetchPage({ apiBase, productId, shopDomain, page, perPage, all: true, filterMode: state.filterMode, forceKey });
              let tmp = dataAll.reviews || [];
              tmp = tmp.filter(r => r.product && r.product.handle === handle);
              if (tmp.length > 0) {
                list = tmp;
                try { console.warn('[JDGM] Fallback used: filtered sitewide reviews by product handle', handle, 'count:', list.length); } catch(_){}
              }
            } catch(_){ }
          }
        }
        const filterMode = state.filterMode;
        // Helper: only allow media when upstream flags allow, otherwise treat as text-only
        const mediaAllowed = (r) => {
          const ms = Array.isArray(r.media) ? r.media : [];
          const flagsKnown = (r.has_published_pictures !== undefined) || (r.has_published_videos !== undefined);
          const flagsAllow = (r.has_published_pictures === true) || (r.has_published_videos === true);
          return flagsKnown ? (flagsAllow && ms.length > 0) : (ms.length > 0);
        };
        // Client-side filtering
        if (filterMode === 'media_or_text'){
          list = list.filter(r => mediaAllowed(r) || (r.body && r.body.trim() !== ''));
        } else if (filterMode === 'media_only'){
          list = list.filter(r => mediaAllowed(r));
        } else if (filterMode === 'text_only'){
          list = list.filter(r => r.body && r.body.trim() !== '');
        }
        // Expand multi-media reviews into separate cards (one per media) only when media is allowed
        if (filterMode !== 'text_only'){
          const expanded = [];
          list.forEach(r => {
            if (mediaAllowed(r)){
              const ms = Array.isArray(r.media) ? r.media : [];
              if (ms.length > 1){
                ms.forEach(m => expanded.push({ ...r, media: [m] }));
              } else {
                expanded.push(r);
              }
            } else {
              expanded.push(r);
            }
          });
          list = expanded;
        }
        if(list.length === 0){
          try { console.warn('[JDGM] No reviews after client-side filtering on page', page, { filterMode, all: state.all }); } catch(_){ }
          done = true;
          if(page === 1){
            loader.style.display = 'none';
            grid.insertAdjacentHTML('beforebegin', ctaHtml(container.dataset.reviewUrl));
            moreBtn.disabled = true;
            moreBtn.textContent = 'No reviews yet';
          } else {
            loader.textContent = 'No more reviews';
            moreBtn.disabled = true;
            moreBtn.textContent = 'No more reviews';
          }
          return;
        }
        const frag = document.createDocumentFragment();
        list.forEach(r => {
          const div = document.createElement('div');
          div.innerHTML = cardHtml(r, { showStars, showTitle, showAuthor, all: state.all, shopDomain, fallbackProduct: {
            image: container.dataset.productImage,
            url: container.dataset.productUrl,
            title: container.dataset.productTitle,
            variant: container.dataset.variantTitle,
          }});
          frag.appendChild(div.firstChild);
        });
        grid.appendChild(frag);
        page += 1;
        loader.style.display = 'none';
        moreBtn.disabled = false;
      }catch(e){
        const status = e && e.status ? ` (${e.status})` : '';
        loader.textContent = `Error loading reviews${status}`;
        console.error('[JDGM] Load error:', e);
        done = true;
        moreBtn.disabled = true;
        moreBtn.textContent = 'Error';
        if (DEBUG && debugPre) {
          try { debugPre.textContent = JSON.stringify({ error: e.message || String(e), status: e.status || null, payload: e.payload || null }, null, 2); } catch(_){}
        }
      } finally {
        loading = false;
      }
    }

    // Infinite scroll
    if (infinite) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if(entry.isIntersecting) load(); });
      }, { root: null, rootMargin: '600px', threshold: 0 });
      observer.observe(moreBtn);
    }

    // Initial
    load();
  }

  function autoInit(){
    document.querySelectorAll('[data-jdgm-grid]')
      .forEach(init);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoInit);
  else autoInit();
})();
